import React from 'react';
import {WithTranslation} from 'react-i18next';
import {get} from 'lodash';

import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
interface Item {
  isFrontline: boolean;
  level: string;
}

interface ClientRoleComponentProps extends WithTranslation {
  item: Item | null;
}

export const ClientRoleComponent: React.FC<ClientRoleComponentProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}) => {
  const isFrontline = get(item, 'isFrontline', false);
  const level = get(item, 'level', '');

  if (isFrontline) {
    return tt('frontline', 'Client · Frontline');
  } else {
    return tt(
      'roleDescription',
      generateComponentCallback({
        component: <>Client · GEN{level}</>,
      }),
    );
  }
};

export default withTranslation('report.record.clientRole')(ClientRoleComponent);
